import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const LocationIcon = ({ color = "offWhite", className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.75 9.58335C10.1974 9.58335 9.66752 9.36386 9.27682 8.97316C8.88612 8.58246 8.66663 8.05256 8.66663 7.50002C8.66663 6.94749 8.88612 6.41758 9.27682 6.02688C9.66752 5.63618 10.1974 5.41669 10.75 5.41669C11.3025 5.41669 11.8324 5.63618 12.2231 6.02688C12.6138 6.41758 12.8333 6.94749 12.8333 7.50002C12.8333 7.77361 12.7794 8.04452 12.6747 8.29728C12.57 8.55004 12.4166 8.7797 12.2231 8.97316C12.0296 9.16662 11.8 9.32007 11.5472 9.42477C11.2945 9.52947 11.0235 9.58335 10.75 9.58335ZM10.75 1.66669C9.20286 1.66669 7.71913 2.28127 6.62517 3.37523C5.53121 4.46919 4.91663 5.95292 4.91663 7.50002C4.91663 11.875 10.75 18.3334 10.75 18.3334C10.75 18.3334 16.5833 11.875 16.5833 7.50002C16.5833 5.95292 15.9687 4.46919 14.8747 3.37523C13.7808 2.28127 12.2971 1.66669 10.75 1.66669Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default LocationIcon;
